import { Component, Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Address, AddressDto } from '../../models/models';
import { ParameterService } from '../../parameter.service';
import { NotifDialogComponent } from '../../notif-dialog/notif-dialog.component';

@Component({
  selector: 'app-address-delete-dialog',
  templateUrl: './address-delete-dialog.component.html',
  styleUrls: ['./address-delete-dialog.component.scss']
})
export class AddressDeleteDialogComponent {

  addressSelected: any;
  public closeResult: string;

  constructor(public formBuilder: FormBuilder, private parameterService: ParameterService,
    private address: Address,
    private modalService: NgbModal, private route: Router, private fbRecharge: FormBuilder
  ) {

  }


  ngOnInit() {
    this.addressSelected = this.address;
  }

  closeModale() {
    this.modalService.dismissAll();
  }

  submit() {
   
    this.parameterService.deleteWithKey("adress/"+this.addressSelected.addressid).subscribe(data => {
      let statuscode = data.status;

      switch (data.status) {

        case 200: {
          // this.getItems();
          this.modalService.dismissAll(true);
          this.openNotifModal('Suppression reussi');

          break;
        }

        default: {
          this.closeModale();
          this.openNotifModal('Une erreur est survenue')
          break;
        }

      }
    },
      error => {

        let statuscode = error.status;
        switch (error.status) {
          case 401:
            this.openNotifModal( 'Adresse introuvable en base');

            break;
            case 409:
              this.openNotifModal( 'Impossible de supprimer l\'adresse par defaut');

            break;

          default:
            this.openNotifModal( 'Echec !! Une erreur est survenue');
            break;
        }
      });
  }


  async openNotifModal(message) {
    this.modalService.open(NotifDialogComponent,
      {
        size: 'xs',
        ariaLabelledBy: 'Cart-Modal',
        centered: true,
        windowClass: 'theme-modal cart-modal CartModal',
        injector: Injector.create([{
          provide: String, useValue: message
        }])
      }).result.then((result) => {

        `Result ${result}`
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


}
